// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { supabase } from '@/lib/supabase'

// 公開頁
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Member from '../views/Member.vue'
import TermsPrivacy from '../views/TermsPrivacy.vue'

// 登入後 App 殼層與內頁
import AppShell from '../views/AppShell.vue'
import Profile from '../views/AppShell/Profile.vue'
import AppFaceTool from '../views/AppShell/AppFaceTool.vue'

// ✅ 你 AppFaceTool 會 push 到這個 name（AppOmniCounsel）
import OmniFaceTool from '../views/AppShell/FaceTool/OmniFaceTool.vue'

const routes = [
  // ===== 公開頁 =====
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: About, meta: { title: '關於我們' } },
  { path: '/contact', name: 'Contact', component: Contact, meta: { title: '聯絡我們' } },

  { path: '/member', name: 'Member', component: Member, meta: { title: '會員登入' } },
  { path: '/terms', name: 'TermsPrivacy', component: TermsPrivacy, meta: { title: '會員條款與隱私權政策' } },

  // ===== App（先留最少頁）=====
  {
    path: '/app',
    component: AppShell,
    meta: { requiresAuth: true, title: '會員中心' },
    children: [
      { path: '', redirect: '/app/profile' },

      {
        path: 'profile',
        name: 'AppProfile',
        component: Profile,
        meta: { requiresAuth: true, title: '會員資料' }
      },

      {
        path: 'facetool',
        name: 'AppFaceTool',
        component: AppFaceTool,
        meta: { requiresAuth: true, title: '工具' }
      },

      // ✅ 補上你正在用的 routeName：AppOmniCounsel
      {
        path: 'facetool/omnicounsel',
        name: 'AppOmniCounsel',
        component: OmniFaceTool,
        meta: { requiresAuth: true, title: 'OMNICounsel' }
      }
    ]
  },

  // (可選) 404
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../views/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

/**
 * ✅ 全域守門員：避免「先閃 member 再跳 app」
 * - 去 /member：如果已登入，直接送去 /app/profile
 * - 去 requiresAuth 的頁：如果未登入，送回 /member
 */
router.beforeEach(async (to, from, next) => {
  try {
    const { data, error } = await supabase.auth.getSession()
    if (error) console.warn('[router] getSession error:', error.message)

    const hasSession = !!data?.session

    // 去 /member：已登入就直接進 AppProfile（不讓 Member 有機會 render）
    if (to.name === 'Member' || to.path === '/member') {
      if (hasSession) return next({ name: 'AppProfile' })
      return next()
    }

    // 需要登入的頁（包含 /app 與其 children）
    const requiresAuth = to.matched.some(r => r.meta?.requiresAuth)
    if (requiresAuth && !hasSession) {
      return next({ name: 'Member' })
    }

    return next()
  } catch (e) {
    console.warn('[router] guard unexpected error:', e?.message || e)

    const requiresAuth = to.matched.some(r => r.meta?.requiresAuth)
    if (requiresAuth) return next({ name: 'Member' })

    return next()
  }
})

export default router
